// ============================================
// FILE: components/quiz/MushafView.tsx
// ============================================
import React, { useState, useEffect } from 'react';
import { LoadingSpinner } from '../common/LoadingSpinner';
import DataService from '../../services/DataService';

export const MushafView: React.FC<{ questionId: string | null }> = ({ questionId }) => {
  const [pages, setPages] = useState<number[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!questionId) {
      setLoading(false);
      setError('No question selected');
      return;
    }

    const loadPages = () => {
      setLoading(true);
      setError(null);
      
      try {
        const verseId = parseInt(questionId);
        const verse = DataService.getVerseByVid(verseId);
        
        if (verse) {
          setPages([verse.page, verse.page + 1]);
        } else {
          setError('Page not found');
        }
      } catch (err) {
        setError('Error loading page');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    loadPages();
  }, [questionId]);

  if (loading) return <LoadingSpinner />;

  if (error) {
    return (
      <div className="bg-white rounded-xl shadow-lg p-8 text-center max-w-4xl w-full">
        <p className="text-red-500">{error}</p>
      </div>
    );
  }

  if (pages.length === 0) {
    return (
      <div className="bg-white rounded-xl shadow-lg p-8 text-center max-w-4xl w-full">
        <p className="text-gray-500">No page found</p>
      </div>
    );
  }

  return (
    <div dir='rtl' className="w-full lg:flex md:flex justify-center items-center gap-4 max-w-full">
      {pages.map((p) => (
        <div key={p} className="bg-white rounded-xl shadow-lg p-2 relative max-w-full h-full">
          <img
            src={`https://qurancompetition.com/quran-images/${p}.png`}
            alt={`Page ${p}`}
            className="quranpageimage"
            loading="lazy"
            onError={(e) => {
              // Fallback if image doesn't exist
              (e.target as HTMLImageElement).src = '';
              (e.target as HTMLImageElement).alt = `Page ${p} not available`;
              (e.target as HTMLImageElement).className = 'w-full h-64 flex items-center justify-center text-gray-400 bg-gray-100 rounded-lg';
            }}
          />
          <span className="absolute top-2 left-2 bg-black/70 text-white px-3 py-1 rounded-full text-sm">
            Page {p}
          </span>
        </div>
      ))}
    </div>
  );
};
